import { VList } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VList,{staticClass:"py-1",attrs:{"dense":"","nav":""}},_vm._l((_vm.colors),function(color){return _c('MenuColor',{key:color.key,attrs:{"color":color.color,"title":color.label,"activeColor":_vm.activeColor},on:{"click":function($event){return _vm.$emit('change', color.color)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }